import React, {useState, CSSProperties} from "react"
import {Swatch, SwatchContainer} from "./Swatch"

export function ColorPicker(
  props: Pick<React.InputHTMLAttributes<HTMLInputElement>, "disabled" | "value"> & {
    value: string
    onChange: (color: string) => void
  }
) {
  const [color, setColor] = useState(props.value)
  return (
    <SwatchContainer>
      <Swatch
        {...props}
        style={
          {
            "--wallet-budget-swatch": color
          } as CSSProperties
        }
        size={40}
        value={color}
        type="color"
        onBlur={({target}) => {
          props.onChange(target.value)
        }}
        onChange={({target}) => {
          setColor(target.value)
        }}
      />
      <Brush />
    </SwatchContainer>
  )
}

function Brush() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" fill="none" viewBox="0 0 16 22">
      <path
        stroke="white"
        d="M15 8.377v1.348c0 .585-.24 1.119-.627 1.505-.386.387-.92.627-1.505.627H3.133c-.586 0-1.119-.24-1.506-.627a2.124 2.124 0 0 1-.626-1.505V8.377m13.999 0H1m14 0V.8H5.95l-.933 1.915a.387.387 0 0 1-.694 0L3.39.799H1v7.578M6.474 18.44h3.055m-3.055 0v-6.583h3.055v6.583m-3.055 0v1.236c0 .411.165.786.43 1.061l.019.017a1.523 1.523 0 0 0 2.157 0 1.52 1.52 0 0 0 .449-1.078V18.44"></path>
    </svg>
  )
}
